import { LinearFilter, RGBAFormat, WebGLRenderTarget } from "three"

export default function createTextureWriterWebGLRenderTarget(
  textureSize: number,
): WebGLRenderTarget {
  // 1. Create a new render target for this tile
  const target = new WebGLRenderTarget(textureSize, textureSize, {
    minFilter: LinearFilter,
    magFilter: LinearFilter,
    format: RGBAFormat,
  })
  return target
}